import { render } from "./Page.vue?vue&type=template&id=5db711b9"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Page.vue?vue&type=style&index=0&id=5db711b9&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/Users/mac_2/workspace/jukebox-goass/_neu/goass-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__